import { render, staticRenderFns } from "./SiteConfig.vue?vue&type=template&id=14611196&scoped=true&"
import script from "./SiteConfig.vue?vue&type=script&lang=js&"
export * from "./SiteConfig.vue?vue&type=script&lang=js&"
import style0 from "./SiteConfig.vue?vue&type=style&index=0&id=14611196&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14611196",
  null
  
)

component.options.__file = "SiteConfig.vue"
export default component.exports